import React from "react";
import { Route, Switch, HashRouter } from "react-router-dom";
// import './App.css';
import "./styles/bootstrap.css";
import "./styles/stepper.css";
import Home from "./pages/home";
import Home2 from "./pages/home2";
import BasicInformationautosave from "./pages/basicinformationautosave";
import BasicInformation from "./pages/basicInformation"
import MainContextProvider from "./context/Main/MainContextProvider";
import IdentitiValidation from "./components/Validation/IdentitiValidation";


function App() {
  return (
    
      <div className="App">
      <HashRouter basename="/mcAccountOpening">
        <Switch>
        <Route exact path="/:merchant" component={Home} />
          {/* <Route path="/:id" component={Home2} />  */}
          {/*<Route path = "/:id" component = {Home} />*/}
          {/*<Route path="/identify" component={IdentitiValidation} />*/}
        </Switch>
      </HashRouter>
    </div>
    
    
  );
}

export default App;
